import { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './AuthProvider'

type ProtectedRouteProps = PropsWithChildren

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const auth = useAuth()

  if (!auth?.user) return <Navigate to="/login" />
  return <>{children}</>
}
